import type { TFeaturedIconColor } from "libs/design-system/src/types/featured_icon/featuredIcon";
import type { IModalHeader } from "libs/design-system/src/types/modal/modal_header";
import type { TModalState } from "libs/design-system/src/types/modal";
import { FeaturedIcon } from "../../FeaturedIcon";
import styles from "./modal-header.module.scss";

const iconColorMap: Record<TModalState, TFeaturedIconColor> = {
  default: 'gray',
  success: 'green',
  warning: 'yellow',
  danger: 'red',
  primary: 'primary'
};

export const ModalHeader = ({
  state = 'default',
  headerIcon,
  title,
  supportingText,
  keepIconDefaultColors,
}: IModalHeader) => {

  return (
    (headerIcon || title || supportingText) &&
    <section className={styles['modal-header']}>
      {
        headerIcon &&
        <div className={styles['modal-header__icon']}>
          <FeaturedIcon
            icon={headerIcon}
            size="xl"
            color={iconColorMap[state]}
            keepIconDefaultColors={keepIconDefaultColors}
          />
        </div>
      }

      {title && <h3 className={styles['modal-header__title']}>{title}</h3>}

      {
        supportingText &&
        <p className={styles['modal-header__supporting-text']}>
          {supportingText}
        </p>
      }
    </section>
  )
}
